import React, { createContext, useContext, useReducer } from "react";
import { sharedSafariReducer } from "../reducers/sharedSafariReducer";
import { initialFilterSharedSafari, initialOrganizeSafari, initialSummary } from "../Data/sharedSafari";

//Create context
export const SharedSafariContext = createContext();

//Initial state
const initialState = {
  //shared sfari Listing
  sharedSafariData: [],
  summary: initialSummary,
  pageIndex: 1,
  filters: initialFilterSharedSafari,
  updateSafariListing: false,

  //shared safari view
  safariViewData: null,
  safariViewLoading: true,
  safariViewError: '',
  intreastedUsersUrl: '',
  commentsUrl: '',
  intreastedUsers: [],
  summaryInstUser: initialSummary,
  pageIndexInstUser: 1,
  totalIntreastedUsers: 0,
  instUserToggle: false,
  userComments: [],
  summaryUserComment: initialSummary,
  pageIndexUserComment: 1,
  reportContentToggle: false,
  commentForFlag: null,

  //Oraganize Share Safari
  toggleOragnize: false,
  noOfStep: 3,
  step: 1,
  organizeSafari: initialOrganizeSafari,
  organizeSafariErrors: initialOrganizeSafari,

  // Fixed Departure
  toggleFixed: false,
  noOfStep_fx: 3,
  step_fx: 1,
  fixedSafari: {
    slug: '',
    share_safari_title: '',
    park_id: '',
    start_date: '',
    end_date: '',
    no_of_safari: '',
    // step-2
    share_safari_agenda_id: '',
    stay_category_id: '',
    estimate_price_min: '',
    estimate_price_max: '',
    total_seat: '',
    share_seat: '',
    // step-3
    shared_safari_image: null,
    safari_plan: '',
    safariPhotoUrl: ''
  },
  fixedSafariErrors: {
    share_safari_title: '',
    park_id: '',
    start_date: '',
    end_date: '',
    no_of_safari: '',
    // step-2
    share_safari_agenda_id: '',
    stay_category_id: '',
    estimate_price_min: '',
    estimate_price_max: '',
    total_seat: '',
    share_seat: '',
    // step-3
    shared_safari_image: null,
    safari_plan: '',
    safariPhotoUrl: ''
  }
};

//Provider
const SharedSafariProvider = ({ children }) => {
  const [sharedSafariState, sharedSafariDispatch] = useReducer(sharedSafariReducer, initialState);


  return (
    <SharedSafariContext.Provider
      value={{
        ...sharedSafariState,
        sharedSafariDispatch,
      }}
    >
      {children}
    </SharedSafariContext.Provider>
  );
};

//hook
export const useSharedSafariContext = () => useContext(SharedSafariContext);

export default SharedSafariProvider;
